import styled from "styled-components";
import { defaultTheme } from "../../../themes/default";

const { colors } = defaultTheme;

export const StyledDetailsDefault = styled.details<{
  $expandable: boolean;
  $previewContent: boolean;
}>`
  width: 100%;
  padding: 8px;
  max-height: 250px;
  border-radius: 5px;
  overflow: hidden;
  box-shadow: 0px 1px 2px 0px rgba(0, 0, 0, 0.3),
    0px 1px 3px 1px rgba(0, 0, 0, 0.15);

  &[open] {
    max-height: 100%;
  }

  &[open] > summary > div > svg {
    transform: rotate(180deg);
  }

  ${({ $previewContent }) =>
    $previewContent &&
    `
    &[open] > summary > :last-child {
      display: none;
    }
  `}

  ${({ $expandable }) => !$expandable && "padding-right: 32px;"}
`;

export const StyledSummaryDefault = styled.summary`
  width: 100%;
  display: flex;
  list-style: none;
  flex-direction: column;
  color: ${colors.ciqBrandDark};

  &::-webkit-details-marker {
    display: none;
  }
`;

export const StyledTitleContainer = styled.div<{ $previewContent: boolean }>`
  display: flex;
  cursor: pointer;
  align-items: center;
  justify-content: space-between;
  ${({ $previewContent }) => $previewContent && "margin-bottom: 16px;"}
`;

export const StyledPreviewContainer = styled.div`
  opacity: 40%;
  overflow: hidden;
  max-height: 180px;
`;
